// @core/api/endpoints/project/get_sprint_burndown.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BurndownResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get sprint burndown
 * Returns burndown chart data showing remaining work over the sprint duration. Includes ideal burndown line and actual progress.
 */
export async function GetSprintBurndown(
  project_id: string,
  sprint_id: string,
  options?: RequestOptions
): Promise<BurndownResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/sprints/:sprint_id/burndown`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':sprint_id', encodeURIComponent(sprint_id));
  const requestOptions = options;
  return client.get<BurndownResponse>(requestPath, { ...requestOptions });
}
